import React from "react";

import Header from "./../../components/Header/";
import Footer from "./../../components/Footer/";

import { Container, Content } from "./styles";
import { Link } from "react-router-dom";

export default function UseTerms() {
  return (
    <Container>
      <Header />
      <Content>
        <h2>Termos de Uso da Plataforma 7Cantos</h2>
        <p className="last-update">Última atualização: 13 de outubro de 2025</p>
        <p>
          Bem-vindo à 7Cantos! Estes Termos de Uso regulam o acesso e a
          utilização da plataforma digital operada pela 7Cantos, disponível no
          endereço eletrônico [www.7cantos.com] (ou outro que vier a
          substituí-lo), que conecta proprietários de imóveis a potenciais
          inquilinos, oferecendo uma experiência de aluguel simplificada, ágil e
          digital.
        </p>
        <h3>1. Aceitação dos Termos</h3>
        <p>
          Ao acessar, navegar ou utilizar os serviços da 7Cantos, você declara
          ter lido, compreendido e aceitado estes Termos de Uso, bem como a
          nossa <Link to="/privacy-politics">Política de Privacidade</Link>. Caso não
          concorde com qualquer disposição, recomendamos que não utilize a
          plataforma. Se você estiver acessando em nome de uma empresa ou outra
          entidade, declara ter autoridade para vinculá-la a estes Termos.
        </p>
        <h3>2. Cadastro e Responsabilidades do Usuário</h3>
        <p>
          Para utilizar determinadas funcionalidades, será necessário criar uma
          conta e fornecer informações pessoais e/ou comerciais corretas,
          completas e atualizadas. O usuário é inteiramente responsável por
          manter a confidencialidade de suas credenciais de acesso (login e
          senha), bem como por todas as atividades realizadas em sua conta. É
          proibido fornecer informações falsas ou de terceiros sem autorização.
        </p>
        <h3>3. Uso Aceitável da Plataforma</h3>
        <p>
          Ao utilizar a 7Cantos, o usuário se compromete a:
          <ul>
            <li>
              Utilizar a plataforma apenas para fins legais e legítimos.
            </li>
            <li>
              Não realizar qualquer atividade que possa prejudicar, interferir
              ou danificar a infraestrutura ou o funcionamento da plataforma.
            </li>
            <li>
              Não utilizar a plataforma para envio de conteúdo ilegal, ofensivo,
              difamatório, discriminatório ou que infrinja direitos de terceiros.
            </li>
            <li>
              Não copiar, reproduzir, distribuir ou explorar comercialmente
              qualquer parte da plataforma sem autorização expressa da 7Cantos.
            </li>
          </ul>
        </p>
        <h3>4. Propriedade Intelectual</h3>
        <p>
          Todos os direitos relativos à marca, nome empresarial, domínio,
          layout, conteúdo, funcionalidades, software, imagens, textos, vídeos
          e demais elementos da plataforma pertencem exclusivamente à 7Cantos ou
          são licenciados a ela. É vedada a reprodução ou utilização não
          autorizada desses elementos.
        </p>
        <h3>5. Serviços Oferecidos</h3>
        <p>
          A 7Cantos atua como intermediadora digital no processo de locação de
          imóveis residenciais, facilitando a conexão entre locadores e
          locatários, com recursos como:
          <ul>
            <li>Anúncio de imóveis;</li>
            <li>Busca e visualização de imóveis disponíveis;</li>
            <li>Intermediação de propostas e comunicação entre as partes;</li>
            <li>Processamento digital de documentos e contratos.</li>
          </ul>
          A 7Cantos não atua como parte contratual da locação, sendo
          responsabilidade exclusiva das partes envolvidas a formalização,
          cumprimento e eventual rescisão do contrato de aluguel.
        </p>
        <h3>6. Alterações na Plataforma e nos Termos</h3>
        <p>
          Nos reservamos o direito de modificar ou encerrar o site a qualquer
          momento, sem aviso prévio. Continuar a usar o site após tais
          modificações constitui sua aceitação dos novos termos.
        </p>
        <h3>7. Limitação de Responsabilidade</h3>
        <p>
          Não nos responsabilizamos por quaisquer danos diretos, indiretos,
          acidentais, especiais ou consequenciais decorrentes do uso ou
          incapacidade de usar nosso site.
        </p>
        <h3>8. Privacidade e Proteção de Dados</h3>
        <p>
          A coleta, o tratamento e a proteção de dados pessoais são realizados
          em conformidade com a <Link to="/privacy-politics">Política de Privacidade da 7Cantos</Link> e
          com a Lei Geral de Proteção de Dados Pessoais (LGPD). Ao utilizar a
          plataforma, você declara estar ciente e de acordo com nossas práticas
          de privacidade.
        </p>
        <h3>9. Cancelamento, Suspensão e Exclusão de Conta</h3>
        <p>
          A 7Cantos poderá suspender ou excluir a conta de qualquer usuário que
          viole estes Termos de Uso, a legislação vigente ou que comprometa a
          segurança ou o bom funcionamento da plataforma. O usuário também
          poderá, a qualquer momento, solicitar a exclusão de sua conta,
          observadas as obrigações legais e contratuais pendentes.
        </p>
        <h3>10. Disposições Gerais</h3>
        <p>
          Legislação aplicável: Estes Termos são regidos pelas leis da República
          Federativa do Brasil. Foro: As partes elegem o foro da Comarca de
          Fortaleza/CE para dirimir quaisquer controvérsias oriundas deste
          instrumento, com renúncia a qualquer outro, por mais privilegiado que
          seja. Validade: Caso alguma cláusula destes Termos seja considerada
          inválida, as demais permanecerão em pleno vigor e efeito.
        </p>
        <h3>11. Contato</h3>
        <p>
          Em caso de dúvidas, sugestões ou solicitações relativas a estes Termos
          de Uso, entre em contato conosco por meio do e-mail:
          <br />
          📧 contato@7cantos.com
        </p>
      </Content>
      <Footer />
    </Container>
  );
}